import { useMobileFiltersContext, ON_BOARDING_STATES } from './OnboardingContext'
import { useFormInput } from '@/components/hooks/useFormInput'
import { FieldText } from './FieldText'
import { FieldDate } from './FieldDate'
import { FieldOption } from './FieldOption'
import { FormOnBoardingButtons } from './OnboardingButtons'
import { FieldFetchOnClick } from './FieldFetchOnClick'
import { genderOptions } from '../helpers/GlobalAssets'
import { FieldBanner } from './FieldBanner'
import { useAccountLayoutContext } from './AccountProfileContext'
import { accountTranslations } from '../helpers/translations'

const NEXT_STEP = ON_BOARDING_STATES.AVATAR

export function OnBoardingAbout() {
  const context = useMobileFiltersContext()
  const currentChild = context.getCurrentChild()
  const [info] = currentChild?.steps ?? {}
  const { formInputs, handleOnChange } = useFormInput({
    firstName: info.firstName ?? '',
    lastName: info.lastName ?? '',
    birthday: info.birthday ?? '',
    gender: info.gender ?? '',
    shoeTag: info.shoeTag ?? ''
  })

  return (
    <form
      className={'flex flex-col gap-4'}
      onSubmit={async (e) => {
        e.preventDefault()

        /** Input is used to */
        const input = {
          firstName: formInputs.firstName.value,
          lastName: formInputs.lastName.value,
          birthday: formInputs.birthday.value,
          gender: formInputs.gender.value,
          shoeTag: formInputs.shoeTag.value
        }

        const birthday = formInputs.birthday.value ? new Date(formInputs.birthday.value) : null
        const birthDay = birthday?.getDate() ?? null
        const birthMonth = birthday?.getMonth() ?? null
        const birthYear = birthday?.getFullYear() ?? null

        /** Omneo Child profile payload */
        const profile = {
          firstName: formInputs.firstName.value,
          lastName: formInputs.lastName.value || 'Unknown',
          gender: formInputs.gender.value,
          shoeTag: formInputs.shoeTag.value,
          birthDay: null,
          birthMonth,
          birthYear
        }

        const { connectionId } = { connectionId: 1 }
        context.handleUpdateConfig({ ...input, connectionId })
        context.handleNextStep(NEXT_STEP)
      }}
    >
      <div className={'flex flex-row gap-4'}>
        <FieldText
          type="text"
          label={accountTranslations.form_labels.first_name}
          placeholder={accountTranslations.form_placeholders.first_name}
          autoComplete="given-name"
          required={true}
          name={formInputs.firstName.key}
          value={formInputs.firstName.value}
          onChange={handleOnChange}
        />
        <FieldText
          type="text"
          label={accountTranslations.form_labels.last_name}
          placeholder={accountTranslations.form_placeholders.last_name}
          autoComplete="family-name"
          name={formInputs.lastName.key}
          value={formInputs.lastName.value}
          onChange={handleOnChange}
        />
      </div>
      <div className="space-y-2">
        <FieldDate
          showDay={false}
          onChange={handleOnChange}
          name={formInputs.birthday.key}
          value={formInputs.birthday.value}
          label={accountTranslations.form_labels.birthday}
        />
        <FieldBanner
          icon="gift"
          content={accountTranslations.kids_profiles.new_profile.birthday_reward}
          className="bg-[#EAF2F9]"
        />
      </div>
      <FieldOption
        {...{
          label: accountTranslations.form_labels.gender,
          name: formInputs.gender.key,
          value: formInputs.gender.value,
          bgColor: 'white',
          required: false,
          onChange: handleOnChange,
          options: genderOptions
        }}
      />
      <div className="space-y-2">
        <FieldFetchOnClick onChange={handleOnChange} name={formInputs.shoeTag.key} value={formInputs.shoeTag.value} />
        <FieldBanner
          icon="information-sm"
          content={`Your child's ${accountTranslations.form_labels.shoe_tag.toLowerCase()} serves as their unique identifier. To edit, simply type above or click the refresh icon to generate a new random tag.`}
          className="bg-warning-bg"
        />
      </div>

      <FormOnBoardingButtons />
    </form>
  )
}
